import { Component, OnInit } from '@angular/core';
import { ProgressoService, MensagemService, Restricoes, Restricao, RestricaoOperador } from 'maestro-ng';
import { Usuario } from '../usuario.model';
import { UsuarioService } from '../usuario.service';
import { DataSourceRouted } from '../../util/data-source-routed';
import { ActivatedRoute, Router } from '@angular/router';
import { NovoUsuarioSistema } from '../novo-usuario-sistema.model';

@Component({
  selector: 'app-usuario-lista',
  templateUrl: './usuario-lista.component.html',
  styleUrls: ['./usuario-lista.component.css'],
})
export class UsuarioListaComponent implements OnInit {
  mostrarCriaUsuarioSistemaModal: boolean;
  mostrarImportarUsuarioSistemaModal: boolean;
  login = '';
  nomeSufixo = '';
  senha = '';
  loginInvalido = false;
  carregando = false;
  usuarioCriado: NovoUsuarioSistema;
  ds: DataSourceRouted<Usuario, number>;

  constructor(
    private service: UsuarioService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ds = new DataSourceRouted<Usuario, number>(
      'administracao-usuario',
      (c) => this.service.recuperarPaginado(c),
      this.mensagemService,
      this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes([
        new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
        new Restricao<string>({ atributo: 'nome', operador: RestricaoOperador.START_WITH }),
      ])
    );
  }

  ngOnInit(): void {}

  abrirCriaUsuarioSistemaModal() {
    this.mostrarCriaUsuarioSistemaModal = true;
  }
  abrirImportarUsuarioSistemaModal() {
    this.mostrarImportarUsuarioSistemaModal = true;
  }

  fecharCriaUsuarioSistemaModal() {
    this.mostrarCriaUsuarioSistemaModal = false;
    this.usuarioCriado = null;
    this.login = '';
    this.nomeSufixo = '';
    this.senha = '';
  }

  fecharImportarUsuarioSistemaModal() {
    this.mostrarImportarUsuarioSistemaModal = false;
    this.usuarioCriado = null;
    this.login = '';
    this.nomeSufixo = '';
    this.senha = '';
  }

  criarUsuarioSistema() {
    this.carregando = true;
    const nomeCompleto = `Sistema ${this.nomeSufixo}`;
    this.service
      .inserirNovoUsuarioSistema({ login: this.login, nome: nomeCompleto, senha: this.senha })
      .then((resposta) => {
        this.carregando = false;
        this.usuarioCriado = resposta;
      })
      .catch((resposta) => {
        this.carregando = false;
        this.mensagemService.addErro('Erro:', resposta.error);
      });
  }

  public importarUsuarioSistema() {
    this.carregando = true;
    this.service.importarUsuarioSistema(this.login)
      .then(resposta => {
        this.carregando = false;
        this.usuarioCriado = resposta;
        this.fecharImportarUsuarioSistemaModal();
        this.mensagemService.addSucesso('Sucesso', 'O usuário foi importado com sucesso');
      })
      .catch(resposta => {
        this.carregando = false;
        this.mensagemService.addErro('Erro:', resposta.error);
      });
  }

  validarLogin() {
    const regex = /^[a-z0-9_-]*$/;
    const cpfRegex = /\d{11}/;
    this.loginInvalido = !regex.test(this.login) || cpfRegex.test(this.login);
  }

  validarFormulario(): boolean {
    this.validarLogin();
    return (
      !this.loginInvalido && this.login.trim().length > 0 && this.nomeSufixo.trim().length > 0 && this.senha.trim().length > 0
    );
  }
}
